import React, { Component } from "react";
import _ from "lodash";
import Button from "../base-components/button"
import { sendAPIRequest } from "shared/utils/requests";

class Scoring extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };

  }

  async submitScoring() {
    const {
      updateOnboardingStep,
    } = this.props;

    const response = await sendAPIRequest(`/onboarding/submit_scoring`, "POST", { });
    if (response.data.status == 'success') {
      updateOnboardingStep(response.data.onboardingStep);
    } else {
      throw new Error("invalid status for scoring submission: " + response.data.status)
    }
  }

  render() {
    const {
      currentContractor,
    } = this.props;

    return (
      <div className="onboarding-transcribing-container">
        <div className="onboarding-title">
          Are You Ready to Start Scoring?
        </div>
        <div className="onboarding-transcribing-submission">
          <Button className="onboarding-submission-button" text="Start Scoring" onClick={()=> this.submitScoring()} />
        </div>
      </div>
    );  }

}

export default Scoring;
